/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const dietFamiliarity = useStore((state) => state.dietFamiliarity);
  const setDietFamiliarity = useStore((state) => state.setDietFamiliarity);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.dietFamiliarity.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={dietFamiliarity}
          onChange={(value) => {
            setDietFamiliarity(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'diet-familiarity',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'beginner'}>
            <span>🐣</span> {t('onboarding.dietFamiliarity.options.beginner')}
          </Option>
          <Option value={'intermediate'}>
            <span>👂</span> {t('onboarding.dietFamiliarity.options.intermediate')}
          </Option>
          <Option value={'expert'}>
            <span>🧠</span> {t('onboarding.dietFamiliarity.options.expert')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
